import { Edc } from "../Edc";

export const edcDefaultValues: Edc = {
  Id: 0,
  Gsdb: "",
  Name: "",
  Details: "",

  // Address
  Street: "",
  ZipCode: "",
  City: "",

  // Country
  CountryId: 0,

  // Region / Area
  Region: "",
  ZipArea: "",

  // GeoCoordinates
  Latitude: undefined,
  Longitude: undefined,
  MgLatitude: undefined,
  MgLongitude: undefined,

  // Alt Address
  AltStreet: "",
  AltZipCode: "",
  AltCity: "",

  // Alt Country
  AltCountryId: 0,

  // Alt Region / Area
  AltRegion: "",
  AltZipArea: "",

  // Alt GeoCoordinates
  AltLatitude: undefined,
  AltLongitude: undefined,
  AltMgLatitude: undefined,
  AltMgLongitude: undefined,
};
